// extracted by mini-css-extract-plugin
export default {"card":"styles_card__jZw0E","value":"styles_value__aMC-C","title":"styles_title__cEW-x","description":"styles_description__nOpnl"};